<template>
  <div class="">
    <img
      :src="require('@/assets/news/combanner.png')"
      alt="Carousel Image"
      style="display: inline-block; width: 100%"
    />
    <!-- 面包屑 -->
    <!-- <div class="x-help-bread">
      首页 <i class="el-icon-arrow-right x-help-icon"></i> 
      新闻资讯
    </div> -->
    <!-- 新闻 -->
    <div class="detail">
      <div class="detail-title">{{ info.title }}</div>
      <div class="detail-box">
        <div class="detail-content" v-html='info.cont'></div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsList } from "@/common/news";
export default {
  data () {
    return {
      list: newsList(),
      info:{}
    }
  },
  created(){
    const num = this.$route.query.num
    this.info = this.list[num]
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
  .x-help-bread {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    background: #00AECF ;
    box-sizing: border-box;
    padding-left: 10%;
    color: #fff;
    font-size: 14px;
    .x-help-icon {
      padding: 0 5px;
      margin-top: 3px;
    }
  }
  .detail{
    width: 80%;
    margin: 0 auto;
    min-width: 1200px;
    .detail-title{
      width: 100%;
      font-size: 20px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-weight: bold;
    }
    .detail-box{
      width: 100%;
      box-sizing: border-box;
      padding: 40px;
      background: #fff;
      margin-bottom: 40px;
      border-radius: 8px;
      .detail-content{
        width: 100%;
        text-align: left;
      }
    }
  }
</style>